import { filtersHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';

export const phoneExtItemModel = (data) => ({
    uuid: data.uuid,
    name: data.name,
    email: data.email,
    phoneCode: data.phone_code,
    phoneNumber: data.phone_number,
    phoneIso: data.phone_iso,
    ext: data.ext,
    didCall: data.did_call,
    sequence: data.sequence,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    user: data.user ? userModel(data.user) : data.user,
});